<template>
	<router-link
		:to="{ path: promo.link.replace(home_url, '') }"
		class="inline-promotion product_wrap col-lg-2 col-md-3 col-sm-4 col-xs-6 product_item product_item_data product_wrap_big product_wrap_big_1 product_wrap_big_2"
		:class="'theme-' + promo.theme"
		:target="promo.new_tab ? '_blank' : '_self'"
		@click.native="clickHandler(promo, $event)"
	>
		<div class="product clearfix">
			<div class="product_big_bg">
				<div
					class="product_big_in"
					:style="'background-image: url(' + assets + '/layout/x-pattern-white.png)'"
				></div>
			</div>
			<div class="ip-pattern" :style="'background-image: url(' + assets + '/layout/x-pattern-white.png)'"></div>
			<div class="ip-container">
				<div
					v-if="promo.image_tall && promo.image_tall.sizes.large"
					class="ip-image-tall"
					:style="'background-image:url(' + promo.image_tall.sizes.large + ');'"
				/>
				<div
					v-if="promo.image_wide && promo.image_wide.sizes.large"
					class="ip-image-wide product_img"
					:style="'background-image:url(' + promo.image_wide.sizes.large + ');'"
				/>
				<p class="ip-content">
					<span class="ip-title pr_price">
						{{ promo.title }}
					</span>
					<span class="ip-text pr_title_note" v-html="promo.subtitle"></span>
					<span class="ip-cta pr_title"> {{ promo.cta_text }} &larr; </span>
				</p>
			</div>
		</div>
	</router-link>
</template>

<script>
	export default {
		name: "InlinePromotion",
		props: ["promo", "home_url", "assets"],
		data() {
			return {};
		},
		methods: {
			clickHandler(promo, e) {
				if (typeof dataLayer !== "undefined") {
					dataLayer.push({
						event: "ga_event",
						category: "inline promotion",
						action: "click",
						label: promo.title,
					});
				}
				return;
			},
		},
	};
</script>

<style lang="scss">
	#homePage {
		.inline-promotion {
			.product {
				min-height: 330px;
				@media (min-width: 1600px) {
					min-height: 337px;
				}

				.ip-container {
					.ip-content {
						.ip-title {
							font-family: "raanancondensed", arial, sans-serif;
							color: #ef4134;
							font-weight: 900;
							font-size: 40px;
							line-height: 21px;
						}

						.ip-text {
							font-weight: 700;
							font-size: 20px;
							line-height: 23px;
							white-space: normal;
						}

						.ip-cta {
							font-weight: 400;
							font-size: 20px;
							line-height: 23px;
							color: #355731;
							margin-bottom: 5px;
						}
					}

					.ip-image-tall {
						height: 298px;
						@media (min-width: 1600px) {
							height: 305px;
						}
					}
				}

				.ip-pattern {
					display: block;
					position: absolute;
					top: 24px;
					width: 47%;
					height: 123px;
					left: 10px;
				}

				.product_big_in {
					display: none;
				}
			}
		}
	}

	#categoryPage {
		.inline-promotion {
			@media (max-width: 480px) {
				padding: 0 7px;
				.product {
					margin: 0;
					height: 328px;

					.ip-container {
						flex-direction: column;
						height: 100%;

						.ip-content {
							display: flex;
							flex-direction: column;
							flex: 1;
							text-align: center;
							padding: 10px 7px 0;

							.ip-title {
								padding: 0;
								margin-bottom: 5px;
								margin-top: 0;
							}

							.ip-text {
								padding: 0;
							}

							.ip-cta {
								margin: auto -15px -8px;
								padding: 5px 0;
								background: #284b24;
								color: #fff;
								border-radius: 0 0 22px 22px;
							}
						}
					}
				}
			}
		}
	}
</style>
<style lang="sass" scoped>

	.ip-container
	  display: flex
	  padding: 1rem

	.ip-image-tall
	  display: block
	  width: 440px
	  height: 285px
	  position: relative
	  z-index: 1
	  border-radius: 22px
	  background-size: cover
	  background-repeat: no-repeat
	  background-position: center center

	.ip-image-wide
	  display: none

	.ip-content
	  width: 100%
	  max-width: calc(100% - 11vw)
	  margin-top: auto
	  padding-top: 1rem
	  padding-right: 22px
	  position: relative
	  z-index: 1

	.ip-title
	  display: block
	  margin-bottom: 11px
	  position: relative
	  z-index: 1

	.ip-text
	  font-size: 14px
	  font-weight: bold
	  display: block
	  margin-bottom: 11px
	  color: #4d5a48
	  white-space: nowrap
	  overflow: hidden
	  text-overflow: ellipsis
	  width: 100%
	  position: relative
	  z-index: 1

	.ip-cta
	  display: block
	  margin-bottom: 22px
	  position: relative
	  z-index: 1

	.ip-pattern
	  display: none

	/* Tablet styles */
	@media screen and (max-width: 1200px)

	  .ip-container
	    display: block

	  .ip-content
	    padding-right: 0
	    max-width: 100%

	  .ip-cta
	    margin-bottom: 11px

	  .ip-image-tall
	    display: none
	  .ip-image-wide
	    display: block
	    height: 161px
	    width: 100%
	    background-size: cover
	    background-repeat: no-repeat
	    background-position: center center
	    border-bottom-left-radius: 22px
	    border-bottom-right-radius: 22px
	    margin-bottom: 11px

	/* Mobile styles */
	@media screen and (max-width: 800px)

	  .ip-container
	    display: flex
	    padding: 0.5rem

	  .ip-content
	    padding-right: 22px
	    max-width: 100%

	  .ip-image-wide
	    // height: 0
	    // padding-bottom: 33.5%
	    //height: auto
	    padding-bottom: 0
	    margin-bottom: 0
	    border-bottom-left-radius: 11px
	    border-bottom-right-radius: 11px

	  .ip-content
	    z-index: 2
	    padding-right: 0

	  .ip-title
	    margin-top: 11.1vw
	    margin-bottom: 2px
	    padding-right: 22px
	  .ip-text
	    font-size: 12px
	    margin-bottom: 2px
	    white-space: normal
	    overflow: visible
	    text-overflow: none
	    width: auto
	    padding-right: 22px
	  .ip-cta
	    margin-bottom: 0
	    padding-right: 22px

	  .ip-pattern
	    display: block
	  position: absolute
	  top: auto
	  bottom: 34px
	  left: 0
	  width: 100%
	  height: 15px
	  background-position: top left
	  background-repeat: repeat
	    z-index: 3

	/* THEMES */
	.inline-promotion.theme-green
	  .ip-container,
	  .ip-content
	    background-color: #cbe5c0
	  /* Mobile */
	  @media screen and (max-width: 800px)
	    .ip-title
	      background-color: #cbe5c0
	    .ip-content
	      background-color: transparent
	    .ip-text
	      color: #626f5c

	.inline-promotion.theme-yellow
	  .ip-container,
	  .ip-content
	    background-color: #fae4b3
	  /* Mobile */
	  @media screen and (max-width: 800px)
	    .ip-title
	      background-color: #fae4b3
	    .ip-content
	      background-color: transparent
	    .ip-text
	      color: #796f58

	.inline-promotion.theme-pink
	  .ip-container,
	  .ip-content
	    background-color: #ffd7e2
	  /* Mobile */
	  @media screen and (max-width: 800px)
	    .ip-title
	      background-color: #ffd7e2
	    .ip-content
	      background-color: transparent
	    .ip-text
	      color: #80676e
</style>
